import { Divider } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useDispatch } from "react-redux";
import CreateEditForm from "../components/finalForm/CreateEditForm";
import RffAddressEditingField from "../components/finalForm/inputs/RffAddressEditingField";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffDollarField from "../components/finalForm/inputs/RffDollarField";
import RffPercentField from "../components/finalForm/inputs/RffPercentField";
import RffSelectField from "../components/finalForm/inputs/RffSelectField";
import RffGroup from "../components/finalForm/shared/RffGroup";
import Flx from "../components/layout/Flx";
import { useEndpointHook } from "../hooks/useEndpointHook";
import { profileClear } from "../redux/actions/profileActions";
import { sidebarClose } from "../redux/reducers/sidebarReducer";

const CreateEditBorrowerExperienceRecordForm = ({
  isEditing,
  initialValues,
  metadata,
}) => {
  const { loading, createBorrowerExperienceRecord } = useEndpointHook();
  const dispatch = useDispatch();

  const onCreate = (formData) => {
    let data = { ...formData };

    createBorrowerExperienceRecord({
      data: data,
      onSuccessFn: (d) => {
        dispatch(profileClear());
        dispatch(sidebarClose());
        // handleCreateLoanSuccess();
      },
    });
  };

  const onUpdate = (formData) => {
    // dispatch(profileClear());
    console.log("onUpdate", { entityId: initialValues?._id, formData });
    return;
    // updateRecord({
    //   data: formData,
    //   onSuccessFn: (d) => {
    //     dispatch(profileClear());
    //     dispatch(sidebarClose());
    //     // handleCreateLoanSuccess();
    //   },
    // });
  };

  if (isEditing) {
    return (
      <CreateEditForm
        onUpdate={onUpdate}
        loading={loading}
        initialValues={initialValues}
        updateButtonText="Update Record"
      >
        <CreateBorrowerExperienceRecordFormQuestions />
      </CreateEditForm>
    );
  }
  return (
    <CreateEditForm
      onCreate={onCreate}
      loading={loading}
      createButtonText="Create Record"
    >
      <CreateBorrowerExperienceRecordFormQuestions />
    </CreateEditForm>
  );
};

const CreateBorrowerExperienceRecordFormQuestions = ({ disabled }) => {
  const experienceTypeOptions = [
    { label: "Fix and Flip", value: "Fix and Flip" },
    { label: "Ground Up Construction", value: "Ground Up Construction" },
    { label: "Rental", value: "Rental" },
    { label: "Multifamily", value: "Multifamily" },
    { label: "Commercial", value: "Commercial" },
    { label: "Other", value: "Other" },
  ];

  // Resolution status options
  const resolutionStatusOptions = [
    { label: "In Progress", value: "In Progress" },
    { label: "Sold", value: "Sold" },
    { label: "Retained as Rental", value: "Retained as Rental" },
    { label: "On the market for sale", value: "On the market for sale" },
  ];
  return (
    <Flx column g={4}>
      <RffGroup title="Experience Details" suppressBottomMargin>
        <RffAddressEditingField
          label={"Property Address"}
          name={"propertyAddress"}
        />
        <RffSelectField
          name="experienceType"
          label="Experience Type"
          size={6}
          options={experienceTypeOptions}
          required
        />
        <RffSelectField
          name="resolutionStatus"
          label="Resolution Status"
          size={6}
          options={resolutionStatusOptions}
          required
        />
      </RffGroup>

      <Divider sx={{ my: 2, borderColor: grey[200] }} />

      <RffGroup title="Property Purchase Information" suppressBottomMargin>
        <RffDateField
          name="propertyPurchaseDate"
          label="Purchase Date"
          size={6}
          required
        />
        <RffDollarField
          name="propertyPurchasePrice"
          label="Purchase Price"
          size={6}
          required
        />
        <RffDollarField
          name="propertyRenovationBudget"
          label="Renovation Budget"
          size={6}
          helperText="Total renovation budget for the property/project"
        />
        <RffDollarField
          name="currentMarketValue"
          label="Current Market Value"
          size={6}
          helperText="For properties retained as rental or not yet sold"
        />
      </RffGroup>

      <Divider sx={{ my: 2, borderColor: grey[200] }} />

      <RffGroup
        title="Property Sale Information"
        suppressBottomMargin
        description="Complete this section if the property has been sold or is on the market"
      >
        <RffDateField name="propertySaleDate" label="Sale Date" size={6} />
        <RffDollarField name="propertySalePrice" label="Sale Price" size={6} />
      </RffGroup>

      <Divider sx={{ my: 2, borderColor: grey[200] }} />

      <RffGroup
        title="Refinance Information"
        suppressBottomMargin
        description="Complete this section if the property was refinanced"
      >
        <RffDateField name="refinanceDate" label="Refinance Date" size={6} />
        <RffDollarField
          name="refinanceAmount"
          label="Refinance Amount"
          size={6}
        />
      </RffGroup>

      <Divider sx={{ my: 2, borderColor: grey[200] }} />

      <RffGroup
        title="Entity Association"
        suppressBottomMargin
        description="Link this experience to an entity if applicable"
      >
        <RffPercentField
          name="borrowerEntityMembershipPercent"
          label="Your Ownership Percentage in Entity"
          size={6}
          helperText="What percentage of the entity do you own?"
        />
      </RffGroup>
    </Flx>
  );
};

export default CreateEditBorrowerExperienceRecordForm;
